module.exports = __webpack_public_path__ + "static/media/icon-close-white.14c7f474.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/icon-close-white.svg
// module id = 248
// module chunks = 0